import React from 'react';

import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { formStyles } from 'consts/styles/Form';
import Auth from 'auth/Auth';
import Icons from 'consts/icons';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import { addAlert } from 'store/actions/alert/alerts';
import { fromUnderScoreToUpperCase } from 'helpers/variablesNamesFit';
import { postRequest } from 'helpers/apiRequests';
import { useLoginStyles } from 'consts/styles/Login';
import ButtonsUseStyles from 'consts/styles/Buttons';

const auth = new Auth();

const SignIn = props => {
  const {
    history,
    language,
    siteLang,
    setSeeableLoader,
    dispatch,
    setType,
  } = props;
  const [values, setValues] = React.useState({
    username: '',
    password: '',
  });
  const [error, setError] = React.useState(false);

  const classes = useLoginStyles();
  const classesButtons = ButtonsUseStyles();
  const formClasses = formStyles();

  const handleChange = event => {
    const { target } = event;
    const { name, value } = target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleResetPassword = () => {
    setType('reset');
  };
  const handleEnterClick = event => {
    if (event.key === 'Enter') {
      login();
    }
  };

  const login = () => {
    setSeeableLoader(true);
    setError(false);
    postRequest('login', {
      username: values.username,
      password: values.password,
    })
      .then(result => {
        if (result.status !== 200) {
          setValues({ username: '', password: '' });
          setSeeableLoader(false);
          setError(true);
          dispatch(
            addAlert({
              title: language.alerts.loginError.title_,
              desc: language.alerts.loginError.desc_,
              type: 'error',
            })
          );
          return;
        }

        setError(false);
        const parsedData = fromUnderScoreToUpperCase(result.data);
        const userSettingsData = parsedData.configuration;

        userSettingsData[UserSessionDataHandler.defaultLanguage] = siteLang;
        userSettingsData[UserSessionDataHandler.defaultTimezone] =
          siteLang === 'pl' ? 'Poland' : 'UTC';
        userSettingsData[UserSessionDataHandler.defaultBuffer] =
          parsedData.buffer || 0;

        UserSessionDataHandler.saveRefreshToken(parsedData.refresh);
        UserSessionDataHandler.saveJurisdiction(parsedData.jurisdiction[0]);
        UserSessionDataHandler.saveJurisdictionWithBuffer(
          parsedData.jurisdictionWithBuffer[0]
        );

        auth.authenticate(parsedData.access, userSettingsData, {
          username: parsedData.username,
          firstName: parsedData.firstName,
          lastName: parsedData.lastName,
          adminPermissions: parsedData.adminPermissions,
          group: parsedData.group,
          phone: parsedData.phone,
          email: parsedData.email,
          address: parsedData.address,
          uid: parsedData.uid,
          organization: parsedData.organization,
        });

        dispatch(
          addAlert({
            title: language.alerts.loginSuccess.title_,
            desc: language.alerts.loginSuccess.desc_,
            type: 'success',
          })
        );
        setSeeableLoader(false);
        history.push('/');
      })
      .catch(error => {
        setSeeableLoader(false);
        setError(true);
        dispatch(
          addAlert({
            title: language.alerts.loginError.title_,
            desc: error.message,
            type: 'error',
          })
        );
      });
  };

  return (
    <>
      <Typography component="h1" variant="h5">
        {language.loginScreen.helloMessage_}
        {'. '}
        {language.loginScreen.message_}
      </Typography>
      <form className={`${classes.Login}__container__paper__form`} noValidate>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          InputLabelProps={{
            classes: {
              outlined: `${formClasses.Form}__text-field`,
              shrink: `${formClasses.Form}__text-field--focused`,
            },
          }}
          InputProps={{
            classes: {
              input: `${formClasses.Form}__text-field`,
              focused: `${formClasses.Form}__text-field--focused`,
            },
          }}
          id="username"
          label={language.loginScreen.username_}
          name="username"
          autoComplete="username"
          autoFocus
          onChange={handleChange}
          value={values.username}
        />
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          InputLabelProps={{
            classes: {
              outlined: `${formClasses.Form}__text-field`,
              shrink: `${formClasses.Form}__text-field--focused`,
            },
          }}
          InputProps={{
            classes: {
              input: `${formClasses.Form}__text-field`,
              focused: `${formClasses.Form}__text-field--focused`,
            },
          }}
          name="password"
          label={language.loginScreen.password_}
          type="password"
          id="password"
          autoComplete="current-password"
          onChange={handleChange}
          onKeyPress={handleEnterClick}
          value={values.password}
        />
        <FormControlLabel
          control={
            <Checkbox
              value="remember"
              className={`${formClasses.Form}__text-field--focused`}
            />
          }
          label={language.loginScreen.rememberMe_}
          className={`${classes.Login}__container__paper__form--hr`}
        />
        <Button
          type="button"
          fullWidth
          className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
          onClick={login}
        >
          {language.loginScreen.button_}
        </Button>
        <Grid container>
          <Grid item xs>
            <Link
              className={`${formClasses.Form}__text-field--focused`}
              classes={{
                underlineHover: `${formClasses.Form}--text-shadow`,
              }}
              variant="body2"
              onClick={handleResetPassword}
            >
              <Icons.Filters.ButtonPublic />
              &nbsp;&nbsp;{language.loginScreen.forgotPassword_}
            </Link>
          </Grid>
        </Grid>
        {error ? (
          <Alert
            severity="error"
            className={`${classes.Login}__message ${classes.Login}__message--border--error`}
          >
            {language.alerts.loginError.desc_}
          </Alert>
        ) : (
          <Paper
            className={`${classes.Login}__message ${classes.Login}__message--hidden`}
          >
            &nbsp;
          </Paper>
        )}
      </form>
    </>
  );
};

SignIn.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object,
  language: PropTypes.object.isRequired,
  setSeeableLoader: PropTypes.func,
  setType: PropTypes.func,
  siteLang: PropTypes.string,
};

const mapStateToProps = state => ({
  language: state.language,
});

export default connect(mapStateToProps)(SignIn);
